module.exports = __webpack_public_path__ + "img/img_02@2x.10fcda07.png";